import React from 'react';
import { Typography, Flex } from 'antd';
import { RightOutlined, EnvironmentOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

/**
 * Botão que abre modal com Google Maps em modo satélite.
 * Formato original do smart-grid-webapp.
 */
const MapButton = ({ rua = 'Geolocalização', bairro = 'do', cidade = 'empreendimento', style, onClick, displayOnly }) => {
    return (
        <div
            style={{
                background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)',
                borderRadius: '12px',
                padding: '20px 24px',
                maxWidth: 400,
                minHeight: 100,
                cursor: displayOnly ? 'default' : 'pointer',
                border: '1px solid #d9d9d9',
                transition: 'all 0.2s',
                ...style,
            }}
            onClick={displayOnly ? undefined : onClick}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = '#FB8500';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = '#d9d9d9';
            }}
        >
            <Flex justify="space-between" align="center">
                <div>
                    <Flex align="center" gap={8}>
                        <EnvironmentOutlined style={{ fontSize: 24, color: '#FB8500' }} />
                        <div>
                            <Title style={{ margin: 0, fontSize: '1.1em' }} level={5}>
                                {rua || 'Clique para ver no mapa'}
                            </Title>
                            <Text type="secondary" style={{ margin: 0, fontSize: '0.9em' }}>
                                {bairro && cidade ? `${bairro} - ${cidade}` : 'Ajudar na localização da usina'}
                            </Text>
                        </div>
                    </Flex>
                </div>
                {!displayOnly && <RightOutlined style={{ fontSize: 20, color: '#2957A4' }} />}
            </Flex>
        </div>
    );
};

export default MapButton;
